// Event listeners for Heyflow events
window.addEventListener('heyflow-screen-view', (event) => {
    console.log('heyflow screen view:', event.detail);
});

window.addEventListener('heyflow-submit', (event) => {
    console.log('heyflow submit:', event.detail);
});

     